import IndustryChecklistI18n from "@/components/landing/shared/IndustryChecklistI18n";
const ChecklistTourismusSection = () => <IndustryChecklistI18n translationPrefix="industryTourismus" />;
export default ChecklistTourismusSection;
